import React, { useContext, useEffect, useState } from "react";
import { LiveChatContext } from "../provider/liveChatContext";
import { Spinner } from "react-bootstrap";

const IsConnectedWS = () => {
  const {
    isConnectedWS,
    reconnectAttempts,
    setReconnectAttempts,
    connectSocket,
    reconnectAttemptsRef,
  } = useContext(LiveChatContext);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (!isConnectedWS) {
      // Tunggu 3 detik sebelum menampilkan overlay
      const timeout = setTimeout(() => setShowOverlay(true), 3000);
      return () => clearTimeout(timeout);
    } else {
      // Jika sudah terkoneksi, langsung sembunyikan overlay
      setShowOverlay(false);
    }
  }, [isConnectedWS]);

  if (!showOverlay) return null; // Jangan tampilkan jika belum waktunya

  return (
    <div className="loading-backdrop">
      <div className="card">
        <div className="card-body text-center">
          <p className="text-dark">
            Connecting... (Attempt {reconnectAttempts})
          </p>
          <button
            className="btn btn-primary"
            style={{ width: "100px" }}
            disabled={reconnectAttempts < 5}
            onClick={() => {
              reconnectAttemptsRef.current = 0;
              setReconnectAttempts(0);
              connectSocket();
            }}
          >
            {reconnectAttempts >= 5 ? (
              "Reconnect"
            ) : (
              <Spinner className="flex-shrink-0" animation="border" size="sm" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default IsConnectedWS;
